export const OPDModel = {
    branch_id: '',
    branch: { name: '' },
    checkup_for:'',
    relationship:'',
    employee_id: '',
    employee: { name: '' },
    family_particular_id: '',
    family: { name: '' },
    appointment_date: new Date().toISOString().split('T')[0], // Sets today's date in 'YYYY-MM-DD' format
  }
  

    
export const CHECKUP_FOR_SELF = 1;
export const CHECKUP_FOR_FAMILY = 2;

export const CHECKUP_FOR_NAMES = {
    1: 'Self',
    2: 'Family',
};

export const CHECKUP_FOR_DROPDOWN_OPTIONS = [
    { value: CHECKUP_FOR_SELF, label: CHECKUP_FOR_NAMES[CHECKUP_FOR_SELF] },
    { value: CHECKUP_FOR_FAMILY, label: CHECKUP_FOR_NAMES[CHECKUP_FOR_FAMILY] },
];

export const CHECKUP_STATUS_PENDING = 1;
export const CHECKUP_STATUS_DONE = 2;

export const CHECKUP_STATUS_NAMES = {
    1: 'Pending',
    2: 'Done',
};


export const CHECKUP_STATUS_DROPDOWN_OPTIONS = [
    { value: CHECKUP_STATUS_PENDING, label: CHECKUP_STATUS_NAMES[CHECKUP_STATUS_PENDING] },
    { value: CHECKUP_STATUS_DONE, label: CHECKUP_STATUS_NAMES[CHECKUP_STATUS_DONE] },
];